export const DEFAULT_AI_COUNTRY = 'GB'

export const AI_MARKETS = [
  { value: 'AR', text: 'Argentina (ARS)' },
  { value: 'AU', text: 'Australia (AUD)' },
  { value: 'AT', text: 'Austria (EUR)' },
  { value: 'BD', text: 'Bangladesh (BDT)' },
  { value: 'BE', text: 'Belgium (EUR)' },
  { value: 'BR', text: 'Brazil (BRL)' },
  { value: 'CA', text: 'Canada (CAD)' },
  { value: 'CL', text: 'Chile (CLP)' },
  { value: 'CN', text: 'China (CNY)' },
  { value: 'CO', text: 'Colombia (COP)' },
  { value: 'CZ', text: 'Czechia (CZK)' },
  { value: 'DK', text: 'Denmark (DKK)' },
  { value: 'EG', text: 'Egypt (EGP)' },
  { value: 'FI', text: 'Finland (EUR)' },
  { value: 'FR', text: 'France (EUR)' },
  { value: 'DE', text: 'Germany (EUR)' },
  { value: 'GR', text: 'Greece (EUR)' },
  { value: 'HK', text: 'Hong Kong (HKD)' },
  { value: 'HU', text: 'Hungary (HUF)' },
  { value: 'IN', text: 'India (INR)' },
  { value: 'ID', text: 'Indonesia (IDR)' },
  { value: 'IE', text: 'Ireland (EUR)' },
  { value: 'IL', text: 'Israel (ILS)' },
  { value: 'IT', text: 'Italy (EUR)' },
  { value: 'JP', text: 'Japan (JPY)' },
  { value: 'KE', text: 'Kenya (KES)' },
  { value: 'MY', text: 'Malaysia (MYR)' },
  { value: 'MX', text: 'Mexico (MXN)' },
  { value: 'NL', text: 'Netherlands (EUR)' },
  { value: 'NZ', text: 'New Zealand (NZD)' },
  { value: 'NG', text: 'Nigeria (NGN)' },
  { value: 'NO', text: 'Norway (NOK)' },
  { value: 'PK', text: 'Pakistan (PKR)' },
  { value: 'PE', text: 'Peru (PEN)' },
  { value: 'PH', text: 'Philippines (PHP)' },
  { value: 'PL', text: 'Poland (PLN)' },
  { value: 'PT', text: 'Portugal (EUR)' },
  { value: 'RO', text: 'Romania (RON)' },
  { value: 'SA', text: 'Saudi Arabia (SAR)' },
  { value: 'SG', text: 'Singapore (SGD)' },
  { value: 'ZA', text: 'South Africa (ZAR)' },
  { value: 'KR', text: 'South Korea (KRW)' },
  { value: 'ES', text: 'Spain (EUR)' },
  { value: 'SE', text: 'Sweden (SEK)' },
  { value: 'CH', text: 'Switzerland (CHF)' },
  { value: 'TH', text: 'Thailand (THB)' },
  { value: 'TR', text: 'Turkey (TRY)' },
  { value: 'UA', text: 'Ukraine (UAH)' },
  { value: 'AE', text: 'United Arab Emirates (AED)' },
  { value: 'GB', text: 'United Kingdom (GBP)' },
  { value: 'US', text: 'United States (USD)' },
  { value: 'VN', text: 'Vietnam (VND)' }
]
